import { useDispatch } from "react-redux";
import { useUpdateEmailMutation } from "../../../Store/Builder/techsbook.api";
import { setEmailChange, setLoader } from "../../../Store/Slice/techsbookSlice";
import showToast from "../../Hooks/toast";

const useUpdateEmailApi = () => {
  const dispatch = useDispatch();
  const [emailApi] = useUpdateEmailMutation();
  const send = (body, setThisModal, setOtherModal) => {
    dispatch(setLoader(true));
    emailApi(body)
      .unwrap()
      .then((res) => {
        dispatch(setLoader(false));
        showToast(res?.label + " " + body?.email, "success");
        dispatch(setEmailChange({ ...body, ...res }));
        setThisModal(false);
        setOtherModal(true);
      })
      .catch((err) => {
        dispatch(setLoader(false));
        showToast(err?.data?.message ?? "Error", "error");
      });
  };

  return {
    send,
  };
};

export default useUpdateEmailApi;
